import React from 'react'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { RegisterItemStringPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemStringPropertyFormItem'
import { RegisterItemSelectPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemSelectPropertyFormItem'
import { RegisterItemDatePropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemDatePropertyFormItem'
import { RegisterItemNumberPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemNumberPropertyFormItem'
import { RegisterItemLinkPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemLinkPropertyFormItem'
import { RegisterItemUserPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemUserPropertyFormItem'
import { RegisterItemDiagramPropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemDiagramPropertyFormItem'
import { RegisterItemTimePropertyFormItem } from '@modules/registers/items/form/properties/RegisterItemTimePropertyFormItem'

export const RegisterItemPropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = (props) => {
  if (!props.register) {
    return null
  }

  switch (props.property.type) {
    case 'STRING':
      return <RegisterItemStringPropertyFormItem {...props} />
    case 'SELECT':
      return <RegisterItemSelectPropertyFormItem {...props} />
    case 'DATE':
      return <RegisterItemDatePropertyFormItem {...props} />
    case 'NUMBER':
      return <RegisterItemNumberPropertyFormItem {...props} />
    case 'USER':
      return <RegisterItemUserPropertyFormItem {...props} />
    case 'LINK':
      return <RegisterItemLinkPropertyFormItem {...props} />
    case 'DIAGRAM':
      return <RegisterItemDiagramPropertyFormItem {...props} />
    case 'TIME':
      return <RegisterItemTimePropertyFormItem {...props} />
    default:
      return null
  }
}
